import React, {useImperativeHandle, useRef} from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import {useRouter} from 'next/router'

import Text from '@component/Text/Text'
import WizContentModal from '@component/modal/WizContentModal'

import WarningIcon from '@svg/common/ic_warning_circle_normal.svg'
import IconNewWindow from '@svg/common/ic_new_window.svg'

interface IProps {
    callback?: () => void
}

const InsufficientGasFeeModal = ({callback}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const t = useTranslation()
    const router = useRouter()
    const [amount, setAmount] = React.useState('')

    useImperativeHandle(ref, () => ({
        show: ({amount}: {amount?: string}) => {
            setAmount(amount)
            modalRef.current.show()
        },
    }))

    const onClose = () => modalRef.current.close()
    const onComplete = () => {
        onClose()
        window.open(t('wallet.insufficient.help.center.link'), '_blank')
    }

    return (
        <WizContentModal
            size={'400'}
            ref={modalRef}
            containerClassName={'sm:px-[20px]'}
            panelClassName={'sm:max-w-[400px] sm:flex-none sm:!rounded-[5px]'}>
            <div className={'flex flex-col items-center justify-center gap-y-[10px]'}>
                <WarningIcon />

                <Text className={'text-h3 text-gray01 dark:text-dark_gray01 text-center'}>
                    {t('wallet.insufficient.gas.fee.modal.title')}
                </Text>
                <Text className={'text-body2 text-gray02 dark:text-dark_gray02 text-center'}>
                    {t('wallet.insufficient.gas.fee.modal.desc', {amount})}
                </Text>

                <div
                    className={'flex items-center justify-center gap-x-[5px] my-5 cursor-pointer'}
                    onClick={onComplete}>
                    <Text className={'text-body2 text-gray02 dark:text-dark_gray02 underline'}>
                        {t('common.see.details')}
                    </Text>
                    <IconNewWindow width={16} className={'w-[16px] fill-gray02 dark:fill-dark_gray02'} />
                </div>
            </div>
        </WizContentModal>
    )
}

export default React.forwardRef(InsufficientGasFeeModal)
